import { render, staticRenderFns } from "./ComentFacAnulada.vue?vue&type=template&id=72c19af9&"
import script from "./ComentFacAnulada.vue?vue&type=script&lang=js&"
export * from "./ComentFacAnulada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports